export default __webpack_public_path__ + "images/0xc71aaf8e486e3f33841bb56ca3fd2ac3fa8d29a8.png";